import React, {Component} from 'react'
import { connect } from 'react-redux'
import { getListSellerVerification } from '../../actions/sellerVerificationAction';

import { Alert, Col, Row, Card, CardBody } from 'reactstrap';

import Paginations from '../../components/Paginations';
import { CardHeaderWithToolbars,Title } from '../../components/Card/CardHeaderWithToolbars';
import FilterContainer from '../../components/Container/FilterContainer/FilterContainer';
import Toolbars from './Filters/Toolbars';
import { DEFAULT_SORT_BY, DEFAULT_PER_PAGE } from '../../constants/settings';
import FilterPanel from './sellerVerifications/FilterPanel';
import privateView from '../../components/hocs/privateView';
import List from './sellerVerifications/List'
import { Th } from '../../components/Tbl';
import Analytics from "../../services/Analytics";
import StatusFilter from './sellerVerifications/StatusFilter';

const defaultParams = {
  sort_by : DEFAULT_SORT_BY,
  per_page : DEFAULT_PER_PAGE,
}

const DEFAULT_ROUTE = '/seller_verification';

class SellerVerification extends Component {
	constructor(props) {
		super(props)
		this.state={
			_params:{
        ...defaultParams
      },
      _list: [],
      _pagination: {},
      _filterOpen: false,
      _successAlertOpen: false
    }
    this._handleApplyFilter = this._handleApplyFilter.bind(this);
    this._handleGoto = this._handleGoto.bind(this);
    this._handleToggleFilterPanel = this._handleToggleFilterPanel.bind(this);
    this._handleRefresh = this._handleRefresh.bind(this);
    this._handleResetFilter = this._handleResetFilter.bind(this);
    this._handleRemoveSuccessAlert = this._handleRemoveSuccessAlert.bind(this);
    this._handleStatusFilterChange = this._handleStatusFilterChange.bind(this);
  }

  componentDidMount(){
    const { email } = this.props.injectedProps;
    this._refreshList();
    Analytics.recordPageView('seller_verification_list', email, {
      url: window.location.href,
      location: this.props.location,
      match: this.props.match
    });
  }

  componentWillReceiveProps(nextProps){
    const { isFetch } = nextProps.sellerVerification;
    if(isFetch !== this.props.sellerVerification.isFetch && !isFetch){
      if(nextProps.sellerVerification.error===null){
        const { data, ...pagination  } = nextProps.sellerVerification.list;
        this.setState({
          _list: data,
          _pagination: pagination
        })
      }
    }
  }

  shouldComponentUpdate(nextProps, nextState){
    if(nextProps.sellerVerification.isSubmit&&nextProps.sellerVerification.isSubmit!==this.props.sellerVerification.isSubmit){
      return false;
    }
    return true;
  }

  _handleApplyFilter(payloadFilter){
    // e.preventDefault();
    // const { sort_by, ..._params } = payloadFilter;
    this.setState({
      _params: {
        ...this.state._params,
        ...payloadFilter,
        page: 1
      }
    },()=>this._getList(this.state._params));
  }

  _getList(rawParams = {}){
    let params = {};
    Object.keys(rawParams)
    .filter(key => rawParams[key]!='')
    .forEach(key=> params[key] = rawParams[key]);
    this.props.getList({params});
  }

  _refreshList(){
    // Exclude page...
    const { page, ..._params } = this.state._params;
    this.setState({
      _params:{ ..._params }
    },()=>this._getList(this.state._params));
  }

  _handleResetFilter(e){
    e.preventDefault();
    // const newState = this.state._filterOpen?{_filterOpen:!this.state._filterOpen}:{};
    this.setState({
      // ...newState,
      _params:{ ...defaultParams },
      _isResetFilter: true
    },()=>this._getList(this.state._params));
  }

  _handleRefresh(e){
    e.preventDefault();
    this._refreshList();
  }

  _handleToggleFilterPanel(e){
    e.preventDefault();
    this._toggleFilterPanel();
  }

  _toggleFilterPanel(){
    this.setState({_filterOpen:!this.state._filterOpen})
  }


  _handleGoto(page){
    const _params=this.state._params;
    _params.page=page;
    this.setState({_params},()=>this._getList(this.state._params));
  }

  _handleRemoveSuccessAlert(){
    this.setState({
      _successAlertOpen: !this.state._successAlertOpen
    })
  }

  _handleStatusFilterChange(status){
    this.setState({_params: {...this.state._params, status}})
    this._getList({
      ...this.state._params,
      status
    })
  }

  _onRenderPagination(){
		if(this.props.sellerVerification.list.status_code===200&&this.props.sellerVerification.list.data.length) {
      return (
        <Paginations
          isLoading={this.props.sellerVerification.isFetch}
          size="sm"
          lastPage={this.props.sellerVerification.list.last_page}
          perPage={this.props.sellerVerification.list.per_page}
          total={this.props.sellerVerification.list.total}
          maxPage={8}
          path={this.props.sellerVerification.list.path}
          currentPage={this.props.sellerVerification.list.current_page}
          prevPageUrl={this.props.sellerVerification.list.prev_page_url}
          nextPageUrl={this.props.sellerVerification.list.next_page_url}
          handleGotoCallback={this._handleGoto}
          onCurrentPageChanged={currentPage => {
            window.scrollTo({
              top: this.tableRef.offsetTop+25,
              behavior: 'smooth'
            })
          }}
        />
      )
		}
		return null;
  }

  render() {
    return (
      <div className="animated fadeIn">
        <Row>
          <Col xs="12">
            <Card>
              <CardHeaderWithToolbars>
                <Title>
                  <i className="fa fa-align-justify"></i>
                  <span>Seller Verification List</span>
                </Title>
                <Toolbars
                  isOpen={this.state._filterOpen}
                  onToggleFilter={this._handleToggleFilterPanel}
                  onRefreshList={this._handleRefresh}
                  onResetFilter={this._handleResetFilter}
                />
              </CardHeaderWithToolbars>
              <FilterContainer>
                <FilterPanel
                  {...this.state._params}
                  isOpen={this.state._filterOpen}
                  onApplyFilter={this._handleApplyFilter}
                  isReset={this.state._isResetFilter}
                  onResetFilterCallback={()=>this.setState({_isResetFilter: false, _filterOpen: false})}
                />
              </FilterContainer>
              <CardBody>
                <Alert color="info" isOpen={this.state._successAlertOpen} toggle={this._handleRemoveSuccessAlert}>
                  <strong>Your list has been updated,</strong> maybe it can affect with your filter. Click (<i className="fa fa-refresh"></i>) button to refresh list.
                </Alert>
                {/* <StatusFilter
                  status={this.state._params.status}
                  onClick={this._handleStatusFilterChange}
                /> */}
                <List
                  innerRefs={tableRef => this.tableRef = tableRef}
                  data={this.state._list}
                  isLoading={this.props.sellerVerification.isFetch}
                  from={this.state._pagination.from}
                  to={this.state._pagination.to}
                  perPage={this.state._pagination.per_page}
                  currentPage={this.state._pagination.current_page}
                  total={this.state._pagination.total}
                  statusCode={this.state._pagination.status_code}
                  defaultRoute={DEFAULT_ROUTE}
                  onRenderHeader={()=>(
                    <tr>
                      <Th>No.</Th>
                      <Th>
                        <div style={{display: 'flex', flexDirection: 'row', alignItems: 'flex-end'}}>
                          <p style={{marginRight: 10, marginBottom: 0}}>
                            Email
                          </p>
                        </div>
                      </Th>
                      <Th>Updated</Th>
                      <Th>Status</Th>
                      <Th>Action</Th>
                    </tr>
                  )}
                />
                {this._onRenderPagination()}
              </CardBody>
            </Card>
          </Col>
        </Row>
      </div>
    );
  }
}

const mapStateToProps=({sellerVerification, auth: { isFetch, isLogged, roles, id, email }})=>
{
	return {
    sellerVerification,
    email,
    guardData: { isFetch, isLogged, roles, id, email }
	}
}
const mapDispatchToProps=(dispatch)=> {
	return {
		getList:(filter)=>dispatch(getListSellerVerification(filter))
	}
}
const enchance = connect(mapStateToProps,mapDispatchToProps);
export default enchance(privateView(SellerVerification, ['supervisor']))